import { RefObject, useEffect, useRef } from 'react'

interface UseInfiniteScrollOptions {
    hasNextPage: boolean
    onLoadMore: () => void
}

export const useInfiniteScroll = <T extends HTMLElement>({
    hasNextPage,
    onLoadMore,
}: UseInfiniteScrollOptions): RefObject<T | null> => {
    const sentinelRef = useRef<T>(null)

    useEffect(() => {
        const sentinel = sentinelRef.current

        if (! sentinel || ! hasNextPage) {
            return undefined
        }

        const observer = new IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                onLoadMore()
            }
        })

        observer.observe(sentinel)

        return () => observer.disconnect()
    }, [hasNextPage, onLoadMore])

    return sentinelRef
}
